import { useEffect } from 'react';

import { DeploymentForm } from '@/components/deployments/form';
import { usePermissions } from '@/hooks/use-permissions';
import { useWorkspaceNavigate } from '@/utils/routes';

function DeploymentCreatePage() {
  const { canManageDeploymentRules } = usePermissions();
  const navigate = useWorkspaceNavigate();

  // Members can't create deployment rules — bounce them back to the register.
  useEffect(() => {
    if (!canManageDeploymentRules) {
      navigate('/deployments', { replace: true });
    }
  }, [canManageDeploymentRules, navigate]);

  if (!canManageDeploymentRules) return null;

  return <DeploymentForm isLoading={false} />;
}

export default DeploymentCreatePage;
